const listaDeCircuitos = (state) => {
    return state.items;
}

const circuitoSelecionado = (state) => {
    return state.selecionado;
}

const relatorioMacrofase = (state) => {
    return state.visaoMacrofase;
}

const indicadorBacklog = (state) => {
    return state.indicadorBacklog;
}

const loadingCircuitos = (state) => {
    return state.carregando
}

export {
    listaDeCircuitos,
    circuitoSelecionado,
    relatorioMacrofase,
    loadingCircuitos,
    indicadorBacklog,
}